(function($){
	$(document).ready(function() {
	
		// console.log('cur-product-safes-content.js loaded!');

		$('.cur-product-safes-content .content-tabs .tabs-container .tab').on('click', function(event) {
			if (!$(this).hasClass('active')) {
				var $tabs = $('.cur-product-safes-content .content-tabs .tabs-container .tab');
				$tabs.removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
				$(this).addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
				$('.cur-product-safes-content .content-container').hide();
				if ($(this).data('tab') == 'videos') {
					$('.cur-product-safes-content .content-container.' + $(this).data('tab')).css('display', 'flex');
				} else {
					$('.cur-product-safes-content .content-container.videos .video iframe').each(function() {
						var $iframe = $(this);
						if (!$iframe.data('orig-src')) {
							$iframe.data('orig-src', $iframe.attr('src'));
						}
						$iframe.attr('src', '');
						$iframe.attr('src', $iframe.data('orig-src'));
					});
					$('.cur-product-safes-content .content-container.' + $(this).data('tab')).show();
				}
			}
		});

	});
})(jQuery);
